import { Button, Stack } from '@mui/material';
import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import useHandleBlLogic from './Bl/useHandleBlLogic';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import useConfirmTurnMessage from '../../Hooks/useConfirmTurnMessage';
import { useAtom } from 'jotai';
import { selectedTimeAtom } from '../../shared/selected.time';
import { selectedDayAtom } from '../../shared/selected.day';
import { SaveAppointment } from '../../adapaters/SaveAppointment';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import Cookies from 'js-cookie';
import PayOptionBackdrop from '../PayOptionBackdrop/PayOptionBackdrop';
import { selectedDoctorAtom } from '../../shared/selected.doctor';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import { selectedDepartmentAtom } from '../../shared/selected.department';

const StepButtons = (props) => {
  const [lockButton, setLockButtons] = useState();

  const {
    steps,
    setSteps,
    isForwardLocked,
    acceptTerms,
    pageConfig,
    turnBaseData,
    doctors,
    specialityService,
    controlBtn_ref,
    departments,
  } = props;

  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const backwardMsg = FindLangKey('get-new-turn-back-step');
  const forwardMsg = FindLangKey('general-public-continue');
  const saveMsg = FindLangKey('general-public-btn-save');

  const btnTextColor = {
    sx: {
      color: `${themeColors.ColorPrimary} !important`,
    },
  };

  // console.log('turnBaseDataturnBaseData ---->',turnBaseData)

  const [HandleForward, HandleBackward] = useHandleBlLogic(
    steps,
    setSteps,
    turnBaseData,
    doctors,
    specialityService,
    departments,
    pageConfig
  );

  const [selectedTime] = useAtom(selectedTimeAtom);

  const [selectedDay] = useAtom(selectedDayAtom);

  const [selectedDoctor] = useAtom(selectedDoctorAtom);
  const [openBackdrop, setBackdrop] = useState(false);

  const [department] = useAtom(selectedDepartmentAtom);

  const confirmMsg = useConfirmTurnMessage(selectedTime);
  const navigate = useContext(GlobalContext)?.navigate;
  const idPatient = JSON.parse(
    Cookies.get('user')
  )?.IdPatient;
  const idNobat = Number(selectedTime?.Id);

  const priceTag = Number(selectedDay?.hazineDaryafteNobat);

  const otherTurns_label = FindLangKey(
    'get-new-turn-btn-label-other-turns'
  );

  const HandleSaveAppointment = () => {
    SwalAlert('warning', confirmMsg, true, () => {
      if (
        selectedDay?.daryafteNobateBaHazine &&
        selectedDay?.hazineDaryafteNobat
      ) {
        setBackdrop(true);
      } else {
        SaveAppointment(
          {
            idPatient: idPatient,
            idNobat: idNobat,
          },
          navigate
        );
      }
    });
    let swalTextElements =
      document.querySelector('.swal-text');
    swalTextElements.style.textAlign = 'center';
  };

  useEffect(() => {
    if (steps && steps !== 7) {
      setLockButtons(true);
      setTimeout(() => {
        setLockButtons(false);
      }, 1200);
    }
  }, [steps]);

  return (
    <React.Fragment>
      <Stack
        sx={{ mt: screenWidth > 1024 ? '3em' : '1em' }}
        direction={
          screenWidth > 1024 ? 'column-reverse' : 'row'
        }
        gap=".5em"
        ref={controlBtn_ref}
      >
        <Button
          variant="contained"
          fullWidth
          {...btnTextColor}
          disabled={
            steps === 0 || !acceptTerms || lockButton
          }
          onClick={HandleBackward}
        >
          {backwardMsg}
        </Button>
        <Button
          variant="contained"
          fullWidth
          {...btnTextColor}
          onClick={
            steps !== 7
              ? HandleForward
              : HandleSaveAppointment
          }
          disabled={
            isForwardLocked ||
            (steps === 7 && !selectedTime) ||
            (departments?.length === 1 && !department) ||
            lockButton
          }
        >
          {steps === 7
            ? saveMsg
            : steps === 4
            ? otherTurns_label
            : forwardMsg}
        </Button>
      </Stack>
      <PayOptionBackdrop
        openBackdrop={openBackdrop}
        setBackdrop={setBackdrop}
        priceTag={priceTag}
        doctorList={doctors}
        navigate={navigate}
        confirmMsg={confirmMsg}
        steps={steps}
      />
    </React.Fragment>
  );
};

export default StepButtons;
